import { request, jwtTokenHeader } from '../utils';
import { GET, REQUEST_TRACER_API } from '../constants';

export const fetchTrace = async (traceId, adId) => {
  return request(
    GET,
    `${REQUEST_TRACER_API}/zipkin-report?trace-id=${traceId}&ad-id=${adId}`,
    {},
    await jwtTokenHeader(),
    'Failed to fetch trace data',
    false
  );
};
